import theme from "CustomMuiTheme";
import { format } from "date-fns";
import { OrderStatus } from "models/Order";

export const getUpdatedAtFormat = (date: string | null): string => {
  if (date !== null) {
    try {
      const dateString = format(new Date(date), "yyyy-MM-dd");
      const timeString = format(new Date(date), "HH:mm");
      return dateString + " " + timeString;
    } catch (e) {
      return "";
    }
  } else {
    return "";
  }
};

export enum FilterOrderStatus {
  ALL = "ALL",
  PENDING = "PENDING",
  INCOMPLETE = "INCOMPLETE",
  COMPLETE = "COMPLETE",
}

export enum SortType {
  NONE = "NONE",
  ASC = "ASC",
  DESC = "DESC",
}

export enum SortBy {
  NONE = "NONE",
  ORDER_NUMBER = "ORDER_NUMBER",
  COMPANY = "COMPANY",
  ORDER_STATUS = "ORDER_STATUS",
  ORDER_STATUS_UPDATED = "ORDER_STATUS_UPDATED",
  LAST_UPDATE = "LAST_UPDATE",
}

export const getOrderStatusString = (orderStatus: OrderStatus): string => {
  switch (orderStatus) {
    case "COMPLETE":
      return "4";
    case "INCOMPLETE":
      return "X";
    case "PENDING":
      return "2";
    default:
      return "Okänd";
  }
};

export const getOrderStatusLongString = (orderStatus: OrderStatus): string => {
  switch (orderStatus) {
    case "COMPLETE":
      return "Slutförd (Status 4)";
    case "INCOMPLETE":
      return "Ej slutförd (Status X)";
    case "PENDING":
      return "Pågående (Status 2)";
    default:
      return "Okänd";
  }
};

export const getOrderStatusColor = (orderStatus: OrderStatus) => {
  switch (orderStatus) {
    case "COMPLETE":
      return theme.palette.success.main;
    case "INCOMPLETE":
      return theme.palette.error.main;
    case "PENDING":
      return theme.palette.warning.main;
    default:
      return theme.palette.common.grey;
  }
};

export const getOrderStatusPropColor = (orderStatus: OrderStatus) => {
  switch (orderStatus) {
    case "COMPLETE":
      return "success";
    case "INCOMPLETE":
      return "error";
    case "PENDING":
      return "warning";
    default:
      return "default";
  }
};
